/** Nav / header / favicon file in `public/` — do not use for hero or OG preview images. */
export const FUWALO_LOGO_PATH = "/logo.png";

/** Organization logo in JSON-LD (`Organization.logo`). */
export const FUWALO_LOGO_ABSOLUTE_URL = "https://fuwalo.com/logo.png";

/** App screenshot for Open Graph, Twitter cards, and `SoftwareApplication` image — not the logo mark. */
export const FUWALO_OG_SCREENSHOT_URL = "https://i.ibb.co/Z1ksnwzz/Capture.png";
